import React from 'react';
import PropTypes from 'prop-types';
import { SelectField, SelectVirtualField } from 'Components';
import NavMobileItem from '../NavMobileItem/NavMobileItem';
import './NavMobileFilter.css';

const getLineCount = (val) => {
  if (val === undefined) return 0;
  if (val === null) return 0;

  const pattern = /[A-Z]/g;
  const uCaseChars = pattern.test(val) ? val.match(pattern).length : 0;
  const lCaseChars = val.length - uCaseChars;
  return Math.ceil((lCaseChars + (uCaseChars * 1.5)) / 30);
};

const NavMobileFilter = ({
  options,
  value,
  title,
  onChange,
  isVirtual,
  filterItemValue,
  showAllProjects,
  setNavState,
}) => (
  <div className="nav-mobile-filter">
    <h3>{title}</h3>
    {
      showAllProjects &&
      <NavMobileItem setNavState={setNavState} value={`View All ${title}s`} filterItemValue="" isActive={filterItemValue === ''} />
    }

    {
      isVirtual ?
        <SelectVirtualField
          deleteRemoves={false}
          backspaceRemoves={false}
          clearable={false}
          onChange={onChange}
          options={options}
          value={value}
          optionHeight={({ option }) => {
            const nodes = option.label.split('\n');
            const lineCounts = [
              getLineCount(nodes[0]),
              getLineCount(nodes[1]),
              getLineCount(nodes[2]),
            ];
            const lineCountsTotal = lineCounts.reduce((a, b) => a + b, 0);
            return (lineCountsTotal * 12) + 16;
          }}
        /> :
        <SelectField onChange={e => onChange(e.target)} options={options} value={value} />
    }
  </div>
);

NavMobileFilter.propTypes = {
  showAllProjects: PropTypes.bool,

  title: PropTypes.string,
  filterItemValue: PropTypes.string,
  isVirtual: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  setNavState: PropTypes.func,
};

export default NavMobileFilter;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobileFilter/NavMobileFilter.jsx